class collectionGridItem extends HTMLElement {
  constructor() {
      super();
      this.mainCollection = this.closest("[js-hb-main-collection]");
      this.desktopPosition = parseInt(this.dataset.hbPositionDesk);
      this.mobilePosition = parseInt(this.dataset.hbPositionMob);
      

      this.init();

  };
  init() {
      this.appendGridItem();
  };

  appendGridItem() {
    const productGrid = this.mainCollection.querySelector("[js-product-grid] .nss_collection_latest_innerdetail_innerloops_innerblock_inneritems_new");
    const isDesktop = document.documentElement.clientWidth > 767;
    const targetPosition = isDesktop ? this.desktopPosition : this.mobilePosition;

    const targetProductItem = productGrid.querySelector(`.lsg-collection-grid__card:nth-child(${targetPosition})`);

    if (targetProductItem) {
        targetProductItem.insertAdjacentHTML("beforebegin", this.innerHTML);
    } else {
        productGrid.insertAdjacentHTML("beforeend", this.innerHTML);
    }
    }
}

customElements.define('collection-grid-item', collectionGridItem);